// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'folder-plus';

export const Component = () => (
  <path d='M8.334 13.782h3.448v-3.4c0-.335.144-.527.479-.527.335 0 .479.192.479.527v3.4h3.448c.335 0 .48.144.48.479 0 .335-.145.527-.48.527H12.74v3.4c0 .335-.144.526-.48.526-.334 0-.478-.191-.478-.526v-3.4H8.334c-.336 0-.48-.192-.48-.527s.144-.479.48-.479ZM24.52 5.927v16.715c0 .24-.096.48-.287.67a.946.946 0 0 1-.67.288H.957a.946.946 0 0 1-.67-.288.946.946 0 0 1-.288-.67V3.006c0-.239.096-.479.287-.718A.946.946 0 0 1 .958 2H9.1c.527 0 .814.24.91.67l.767 2.3h12.787c.24 0 .48.096.67.287a.946.946 0 0 1 .288.67Zm-.958 16.715V5.927H10.105L9.1 3.007H.959v19.635h22.605Z' />
);

export const viewBox = '0 0 25 25';
